<template>
  <div>
    <pcHeaders></pcHeaders>

    <div class="aiBg">
      <img src="../assets/images/aiBg.png" alt="" />
      <div class="btn_Ai" @click="handleOpen">立即体验</div>
    </div>
    <div class="aiGroup_1">
      <div class="title1">AI 智能答疑助手・高效备考利器</div>
      <div class="box_1">
        <div class="box_left">
          <div class="list">
            <div class="icon"><img src="../assets/images/Group 427320370.svg" alt="" /></div>
            <div style="margin-left: 12px">
              <div class="text_1">智能答疑引擎</div>
              <div class="text_2">7×24 小时不间断响应，随时精准解答备考疑问，实现问题快速匹配与解决。</div>
            </div>
          </div>
          <div class="list">
            <div class="icon"><img src="../assets/images/Group 427320372.svg" alt="" /></div>
            <div style="margin-left: 12px">
              <div class="text_1">权威教研审核</div>
              <div class="text_2">由持证教研团队全程把关，知识库紧密贴合教材与考试大纲，确保答案专业可靠。</div>
            </div>
          </div>
          <div class="list">
            <div class="icon"><img src="../assets/images/Group 427320374.svg" alt="" /></div>
            <div style="margin-left: 12px">
              <div class="text_1">专属知识图谱</div>
              <div class="text_2">沉淀海量教育数据与真实提问，构建考证领域专属知识体系，精准定位考点需求。</div>
            </div>
          </div>
          <div class="list">
            <div class="icon"><img src="../assets/images/Group 427320375.svg" alt="" /></div>
            <div style="margin-left: 12px">
              <div class="text_1">实时内容更新</div>
              <div class="text_2">同步跟进教材版本与考试政策变动，实时补充最新考点，紧跟备考节奏。</div>
            </div>
          </div>
        </div>
        <div class="box_right">
          <img src="../assets/images/ai2.png" alt="" />
        </div>
      </div>
    </div>
    <div class="aiGroup_2">
      <div class="title1">AI 智能学习助手・专业级学习解决方案</div>
      <div class="box_1">
        <div class="box_right">
          <img src="../assets/images/Group 427320368@2x.png" alt="" />
        </div>
        <div class="box_left">
          <div class="list">
            <div class="icon"><img src="../assets/images/Group 427320380.svg" alt="" /></div>
            <div style="margin-left: 12px">
              <div class="text_1">一站式学习平台</div>
              <div class="text_2">整合各类智能学习工具并统一归类，打造高效便捷的一站式学习体验。</div>
            </div>
          </div>
          <div class="list">
            <div class="icon"><img src="../assets/images/Group 427320382.svg" alt="" /></div>
            <div style="margin-left: 12px">
              <div class="text_1">7×24 小时智能伴学</div>
              <div class="text_2">提供全天候智能伴学服务，助力高效利用碎片化学习时间。</div>
            </div>
          </div>
          <div class="list">
            <div class="icon"><img src="../assets/images/Group 427320384.svg" alt="" /></div>
            <div style="margin-left: 12px">
              <div class="text_1">个性化学习报告</div>
              <div class="text_2">实时推送可视化数据看板，直观呈现学习进度，辅助针对性提升。</div>
            </div>
          </div>
          <div class="list">
            <div class="icon"><img src="../assets/images/Group 427320386.svg" alt="" /></div>
            <div style="margin-left: 12px">
              <div class="text_1">全流程答疑覆盖</div>
              <div class="text_2">覆盖答疑全流程场景，完美适配从提问到解决的完整需求。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="aiGroup_3">
      <img src="../assets/images/Group 427320407@2x.png" alt="" />
    </div>

    <!-- 模态框遮罩层 -->
    <div class="modal-overlay" v-if="dialogVisible" @click.self="handleClose">
      <div class="dialog">
        <div class="dialog-header">
          <div style="display: flex; align-items: center">
            <span><img src="../assets/images/Mask group@2x (4).png" alt="" style="width: 80px; height: 61px; margin-left: 20px" /></span>
            <span><img src="../assets/images/Group 266@2x (1).png" alt="" style="width: 36px; height: 36px; margin-left: 27px" /></span>
            <span class="text_3">智能学习助手</span>
          </div>
          <span class="close-btn" @click="handleClose">
            <img src="../assets/images/Vector.svg" alt="" />
          </span>
        </div>

        <div class="dialog-body">
          <div class="reply">
            <div class="time">{{ currentTime }}</div>
            <div class="info">
              <div class="text_4"><span style="color: #3c5be0">HI,</span>我是您的专属ai学习助手</div>
              <div class="text_5">需要哪方面的帮助，随时告诉我吧～</div>
            </div>
          </div>

          <!-- 问题列表 -->
          <div class="problem">
            <div class="text_6">
              <img src="../assets/images/Mask group.svg" alt="" style="width: 36px; height: 28px; margin-right: 10px" />
              <span>您可以试着问我</span>
            </div>
            <div class="group_6">
              <div class="wtList" v-for="(question, qIndex) in Object.keys(qaMap)" :key="qIndex" @click="handleQuestionClick(question)">
                {{ question }}
              </div>
            </div>
          </div>
          <div v-for="(item, index) in chatHistory" :key="index" :class="['message-item', item.type]">
            <div v-if="item.type === 'question'" class="reply1">
              <div class="time">{{ item.time }}</div>
              <div class="info1">
                <div>{{ item.content }}</div>
              </div>
            </div>
            <div v-else-if="item.type === 'answer'" class="answer">
              <div class="time">{{ item.time }}</div>
              <div class="answerText" v-html="item.content"></div>
            </div>
          </div>
          <div class="search">
            <span style="margin-left: 20px">清晰描述，快速获取ai解答</span>
            <div class="searchBth">发送</div>
          </div>
        </div>
      </div>
    </div>

    <pcBottom></pcBottom>
  </div>
</template>

<script>
import pcHeaders from './component/head.vue';
import pcBottom from './component/bottom.vue';
import Baywindow from './component/Baywindow.vue';
import flotRight from '@/views/component/flotRight.vue';

export default {
  components: {
    pcHeaders,
    pcBottom,
    Baywindow,
    flotRight
  },
  data() {
    return {
      dialogVisible: false,
      currentTime: this.formatDate(new Date()),
      chatHistory: [],
      qaMap: {
        '内蒙古人才库(打印审验卡)的电话是多少？': '0471-6923739、6928486、6269796<br>服务时间：工作日 8:30-12:00 13:00-17:30',
        '如何打印往年的成绩单和查询之前的学习记录？':
          '学员需要打印往年的成绩单或者查询往年培训记录，登录之前学习平台内蒙古人才培训网呼和浩特分站（<a href="https://hszj.nmgrcpx.com/" target="_blank" style="color:#4076f6">https://hszj.nmgrcpx.com/</a>）<br><br>客服电话 400-160-8686 / 18947133868',
        '老平台的账户密码不能直接登录？':
          '呼和浩特专业技术人员继续教育在线学习网（<a href="https://hhht.nmgrcw.com/" target="_blank" style="color:#4076f6">https://hhht.nmgrcw.com/</a>）是2025年4月3日全新上线的继续教育平台，没有之前老平台数据，需要学员重新注册登录。',
        '继续教育要完成多少学时？':
          '根据呼和浩特市人力资源和社会保障局发布的《关于开展2025年全市专业技术人员继续教育公需科目、专业科目网络学习的通知》<br><br>2025年呼和浩特市本级范围内企事业单位专业技术人员公需科目课程需完成30学时，专业科目课程需完成60学时，总共90学时。',
        '继续教育的学习时间？':
          '根据呼和浩特市人力资源和社会保障局发布的《关于开展2025年全市专业技术人员继续教育公需科目、专业科目网络学习的通知》<br><br>2025年继续教育学习时间为2025年4月3日—2025年12月31日，逾期不再开网学习，请学员合理安排学习时间。<br><br>未完成2023年、2024年继续教育公需科目、专业科目学习的专业技术人员，可于2025年4月3日—2025年12月31日内登录呼和浩特市人事考试信息网（<a href="http://www.hhpta.org.cn" target="_blank" style="color:#4076f6">http://www.hhpta.org.cn</a>）直接点击“继续教育”栏目或查找 “呼和浩特专业技术人员继续教育在线学习网”（<a href="https://hhht.nmgrcw.com" target="_blank" style="color:#4076f6">https://hhht.nmgrcw.com</a>）进行补学。<br><br>专业技术人员学完所学科目计划且考试合格后，自行打印证书并妥善保管。 按照内蒙古自治区审验卡全面实行网上办理的要求，学员完成公需科目学习后，同时需完成专业科目的学习，之后登录内蒙古人才信息库（<a href="http://www.nmgrck.cn" target="_blank" style="color:#4076f6">www.nmgrck.cn</a>）自行打印审验卡。',
        '继续教育要费用是多少？':
          '根据呼和浩特市人力资源和社会保障局发布的《关于开展2025年全市专业技术人员继续教育公需科目、专业科目网络学习的通知》<br><br>2025年继续教育网络培训公需科目共30个学时，学员登录呼和浩特专业技术人员继续教育在线学习网（<a href="https://hhht.nmgrcw.com" target="_blank" style="color:#4076f6">https://hhht.nmgrcw.com</a>）注册后可免费学习；<br><br>2025年继续教育网络培训专业科目及2023、2024年公需科目、专业科目补学收费按《内蒙古自治区发展改革委 财政厅关于进一步加强培训收费管理工作有关问题的通知》（内发改费字〔2018〕1399号）收取，每学时收费2.5元，学员可自行登录呼和浩特专业技术人员继续教育在线学习网（<a href="https://hhht.nmgrcw.com" target="_blank" style="color:#4076f6">https://hhht.nmgrcw.com</a>）注册缴费后即可学习。',
        '继续教育专业课都有哪些课程？':
          '根据呼和浩特市人力资源和社会保障局发布的《关于开展2025年全市专业技术人员继续教育公需科目、专业科目网络学习的通知》<br><br>2025年专业技术人员继续教育专业科目共开设十七类课程，每类60学时，包括：经济、新闻、艺术、图书资料、中小学教师（含幼儿园教师）、建设工程、水利工程、化工工程、机械工程、 林草工程、生态环境、电子工程、文物博物、农牧业（畜牧）、 农牧业（兽医）、公共法律服务（公证）、其他（通识）课程， 专业科目课程不设考试，学员可结合自身情况选课学习， 学习完成后学时数计入学员继续教育专业科目总学时，学员可自行打印证书。'
      }
    };
  },
  methods: {
    handleOpen() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.chatHistory=[]
    },
 
   formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}.${month}.${day} ${hours}:${minutes}`;
    },
    updateTime() {
      this.currentTime = this.formatDate(new Date());
    },
    handleQuestionClick(question) {
      const now = new Date();
      const currentTimeStr = this.formatDate(now);

      this.chatHistory.push({
        type: 'question',
        content: question,
        time: currentTimeStr
      });

      const answer = this.qaMap[question] || '暂无答案';

      this.chatHistory.push({
        type: 'answer',
        content: answer,
        time: currentTimeStr
      });

      // 自动滚动到底部
      this.$nextTick(() => {
        const body = this.$el.querySelector('.dialog-body');
        if (body) body.scrollTop = body.scrollHeight;
      });
    }
  },
  mounted() {
      this.updateTime();
    this.timer = setInterval(this.updateTime, 1000);
  },
   beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>
<style lang="less" scoped>
.aiBg {
  width: 100%;
  height: 600px;
  position: relative;
  img {
    width: 100%;
    height: 600px;
  }
}
.aiGroup_1 {
  width: 100%;
  height: 800px;
  padding: 118px 262px 138px 258px;

  .box_1 {
    margin-top: 57px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .box_left {
      .list {
        display: flex;
        margin-top: 30px;
        .icon {
          width: 36px;
          height: 36px;
          background: linear-gradient(254deg, #2978fe 0%, #3d5ce0 100%);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    .box_right {
      width: 620px;
      height: 420px;
      img {
        width: 620px;
        height: 420px;
      }
    }
  }
}
.btn_Ai {
  width: 150px;
  height: 44px;
  background: linear-gradient(254deg, #2978fe 0%, #3d5ce0 100%);
  border-radius: 22px 22px 22px 22px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 44px;
  cursor: pointer;
  position: absolute;
  top: 392px;
  left: 262px;
}
.aiGroup_2 {
  width: 100%;
  height: 800px;
  padding: 118px 262px 138px 258px;

  .box_1 {
    margin-top: 57px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .box_left {
      .list {
        display: flex;
        margin-top: 30px;
        .icon {
          width: 36px;
          height: 36px;
          background: linear-gradient(254deg, #2978fe 0%, #3d5ce0 100%);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    .box_right {
      width: 620px;
      height: 420px;
      img {
        width: 620px;
        height: 420px;
      }
    }
  }
}
.aiGroup_3 {
  img {
    width: 100%;
    height: 880px;
  }
}
.title1 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 42px;
  color: #333333;
}
.text_1 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 20px;
  color: #333333;
}
.text_2 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  margin-top: 8px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog {
  width: 600px;
  height: 780px;
  background: #f4f8fe;
  box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.dialog-header {
  width: 600px;
  height: 80px;
  background: linear-gradient(90deg, #d3dcf8 0%, #e1f0ff 28.85%, #c7deff 66.35%, #f5eeff 100%);
  border-radius: 20px 20px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 20px 24px;
  // border-bottom: 1px solid #e8e8e8;
  // font-size: 18px;
  // font-weight: bold;
  // color: #333;
}
.text_3 {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 800;
  font-size: 24px;
  color: #333333;
  margin-left: 11px;
}
.text_4 {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 800;
  font-size: 20px;
  color: #333333;
}
.time {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}
.info {
  width: 560px;
  height: 88px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  margin-top: 6px;
  padding: 17px 20px;
}
.close-btn {
  font-size: 24px;
  cursor: pointer;
  margin-right: 28px;
}

.close-btn:hover {
  color: #333;
}

.dialog-body {
  flex: 1;
  padding-top: 20px;
  padding-left: 20px;
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  overflow-y: scroll;
  padding-bottom: 160px;
}

.btn-confirm {
  padding: 8px 20px;
  border: none;
  background: linear-gradient(254deg, #2978fe 0%, #3d5ce0 100%);
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #fff;
  transition: opacity 0.3s;
}

.btn-confirm:hover {
  opacity: 0.9;
}
.problem {
  width: 560px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  margin-top: 12px;
  padding: 16px 20px;
}
.text_6 {
  display: flex;
  align-items: center;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
}
.group_6 {
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;

  .wtList {
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 255px;
    height: 61px;
    background: #e8f2ff;
    margin-bottom: 8px;
    border-radius: 6px 6px 6px 6px;
    padding: 0px 20px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }
}
.search {
  width: 560px;
  height: 52px;
  background: #ffffff;
  border-radius: 32px 32px 32px 32px;
  border: 1px solid #4076f6;
  position: absolute;
  bottom: 30px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .searchBth {
    width: 80px;
    height: 44px;
    background: #4076f6;
    border-radius: 32px 32px 32px 32px;
    margin-right: 4px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 44px;
  }
}
.answer {
  margin-top: 27px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  .answerText {
    padding: 20px;
    max-width: 432px;
    background: #fff;
    border-radius: 12px 12px 12px 12px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    margin-top: 6px;

  }
}
.reply1 {
  margin-top: 27px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  .info1 {
    padding: 20px;
    width: auto;
    background: #4076f6;
    border-radius: 12px 12px 12px 12px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    margin-top: 6px;
  }
}
</style>
